import React from 'react';
import { FormattedMessage } from "react-intl";
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
  } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import PhoneIcon from '@material-ui/icons/Phone';
import PaymentDialog from "./PaymentDialog";

class CustomCheckBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: false,
            showReason: false
        }
    }

    handleChange = (e, id) => {
        this.props.onChange(id);
        this.setState({ checked: e.target.checked });
        // Tu lógica personalizada aquí
      };
    
    handleClickDisabled = () => {
        if (this.props.disabled) {
            this.setState({ showReason: true });
        }
    };
    
    handleCloseDialog = () => {
    this.setState({ showReason: false });
    };

    render() {

        const { id, name, value, disabled } = this.props;

        const checkbox = (
            <Checkbox
                checked={this.state.checked}
                onChange={(e) => this.handleChange(e, id)}
                disabled={disabled}
                name={name.toString()}
                color="secondary"
                id={id.toString()}
                checkedIcon={<CheckIcon className="payment-checked-icon" />}
            />
        );

        return (
            <>
                <FormGroup row>
                    <div onClick={this.handleClickDisabled} style={{ cursor: disabled ? 'pointer' : 'default' }}>
                        <FormControlLabel
                            control={checkbox}
                            className={`${this.props.class} ${this.state.checked ? 'checked' : ''}`}
                            label={value}
                        />
                    </div>
                </FormGroup>

                <Dialog open={this.state.showReason} onClose={this.handleCloseDialog}>
                    <DialogContent>
                        <PaymentDialog/>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseDialog} color="primary">Cerrar</Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export {CustomCheckBox};
